import {
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  SearchFieldV2 as SearchField,
  FormFieldV2 as FormField
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import type { SearchFieldActions, SearchFieldState } from '../../hooks';
import { AccountModel, KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const BasicInfoTab = ({ formState: { state, actions } }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-[150px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeField
          label='Ngày c/từ (từ/đến)'
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          toFieldClassName='w-40'
          fromFieldClassName='w-40'
        />
      </div>

      <DocumentNumberRangeField label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã nhà cung cấp:</Label>
        <SearchField<KhachHang>
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.NHA_CUNG_CAP}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          onRowSelection={actions.setNhaCungCap}
          value={state.nhaCungCap?.customer_code}
          relatedFieldValue={state.nhaCungCap?.customer_name}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Tài khoản có</Label>
        <SearchField<AccountModel>
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          onRowSelection={actions.setTaiKhoanCo}
          value={state.taiKhoanCo?.code}
          relatedFieldValue={state.taiKhoanCo?.name}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='dien_giai' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
